//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BM from '../components/js/common';

export default {
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {
    // var hasPaySuccess = false;
    // try {
    //   hasPaySuccess = localStorage.getItem('bPaySuccess');
    // } catch (err) {
    //   // console.log(err)
    // }
    // if (hasPaySuccess) {
    //   localStorage.removeItem('bPaySuccess');
    // }
  },
  methods: {
    // openApp() {
    //     //app下载地址
    //     let iosDownloadUrl = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.fanxing.vip';
    //     let androidDownloadUrl = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.fanxing.vip';
    //
    //     if(BM.isAndroid()){
    //         window.location.href = androidDownloadUrl
    //     }else{
    //         window.location.href = iosDownloadUrl
    //     }
    // },
  }
}



// WEBPACK FOOTER //
// ./src/pages/Success.vue